import { StyledIcon } from "@styled-icons/styled-icon"
import classNames from "classnames"
import { ColoredIconProps, NewTab } from "components/LEGACY/styled-components/Icons"
import Link from "next/link"
import { useRouter } from "next/router"
import { ReactNode, createElement } from "react"
import { StyledComponent } from "styled-components"

interface SidebarLinkProps {
  children: ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: StyledComponent<StyledIcon, any, ColoredIconProps, never>
  href: string
  marked?: boolean
  markedTop?: boolean
  markedBottom?: boolean
  bottom?: boolean
  newTab?: boolean
}
const SidebarLink = ({ children, href, icon, marked, markedTop, markedBottom, bottom, newTab }: SidebarLinkProps) => {
  const router = useRouter()
  const active = router.pathname.startsWith(href)
  return (
    <>
      <style jsx>{`
        .navItem {
          display: flex;
          position: relative;
          align-items: center;
          gap: 0.5rem;
          padding: 1rem 1.5rem;
          width: 100%;
          transition: all 0.2s ease;
          color: white;
          white-space: nowrap;
          text-decoration: none;
        }
        .navItem:visited {
          color: white;
        }
        .navItem:hover,
        .navItem.active {
          background: white;
          color: var(--primary);
        }
        .navItem:hover::after,
        .navItem.active::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: var(--primary);
        }

        .markedTop {
          border-top: 1px solid white;
        }
        .markedBottom {
          border-bottom: 1px solid white;
        }
        .bottom {
          margin-top: auto;
        }
      `}</style>
      <li className={bottom ? "bottom" : ""}>
        <Link href={href} passHref>
          <a
            target={newTab ? "_blank" : ""}
            {...(active ? { ["aria-current"]: "page" } : {})}
            className={classNames({
              navItem: true,
              active: active,
              markedTop: marked || markedTop,
              markedBottom: marked || markedBottom,
            })}
          >
            {createElement(icon, { size: "18", color: "currentColor", width: "18" })} {children} {newTab && <NewTab />}
          </a>
        </Link>
      </li>
    </>
  )
}

export default SidebarLink
